import { Helmet } from "react-helmet-async";

const SITE_URL = "https://zafarabenin.fr";
const DEFAULTS = {
  title: "Zafara Bénin – Livraison à domicile à Cotonou | App marketplace",
  description:
    "Achète et vends en ligne au Bénin avec Zafara. Livraison rapide à Cotonou, paiement Mobile Money sécurisé. Télécharge l'app iOS & Android.",
  image: `${SITE_URL}/og-image.png`,
};

export const SEO = ({ title, description, path = "/", image, noindex = false }) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} · Zafara Bénin`
    : DEFAULTS.title;
  const desc = description || DEFAULTS.description;
  const ogImage = image || DEFAULTS.image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export { SITE_URL };
